const getTermsAndPrivacyContent = (copy) => {
  const emptyContent = {
    beforeTerms: "",
    termsLinkText: "",
    between: "",
    privacyLinkText: "",
    afterPrivacy: "",
  };

  const template = copy.loyalty_terms_privacy_hyperlink_copy;
  const customerCopy = copy.loyalty_terms_privacy_customer_copy;
  const [beforeTerms = "", afterTerms = ""] = template.split("%{termslink}");
  const [between = "", afterPrivacy = ""] = afterTerms.split(
    "%{privacypolicylink}",
  );

  if (
    !afterTerms ||
    afterPrivacy === undefined ||
    !customerCopy.startsWith(beforeTerms) ||
    !customerCopy.endsWith(afterPrivacy)
  ) {
    return emptyContent;
  }

  const contentWithoutPrefix = customerCopy.slice(beforeTerms.length);
  const privacyStartIndex = contentWithoutPrefix.lastIndexOf(afterPrivacy);

  if (privacyStartIndex < 0) {
    return emptyContent;
  }

  const contentWithoutSuffix = contentWithoutPrefix.slice(0, privacyStartIndex);
  const betweenIndex = contentWithoutSuffix.indexOf(between);

  if (betweenIndex < 0) {
    return emptyContent;
  }

  return {
    beforeTerms,
    termsLinkText: contentWithoutSuffix.slice(0, betweenIndex),
    between,
    privacyLinkText: contentWithoutSuffix.slice(betweenIndex + between.length),
    afterPrivacy,
  };
};

export default getTermsAndPrivacyContent;
